import {
  GTMVideoMessageInteractionAction,
  GTMVideoMessageInteractionActions,
  GTMVideoMessageProperties,
} from './types';
import { pushToDataLayer } from '../../pushToDataLayer';
import {
  GTMEvent,
  GTMEventAttributes,
  GTMEventName,
  GTMVideoAttributes,
} from '../../types';
import { mapToGTMVideoAttributes } from '../../utils';
import { mapToGtmVideoMessageProperties } from './utils';

/**
 * useVideoMessageInteractionCalculation use with this hook to easier grab data
 *
 *
 * @example shareTab.tsx
 */
export function videoMessageInteractionEvent({
  action,
  shareOption,
  videoMessageProperties,
  video,
  vehicleData,
}: GTMVideoMessageInteractionActions): void {
  const base: GTMEventAttributes = {
    event: GTMEvent.COVIDEO_EVENT,
    event_name: GTMEventName.VIDEO_MESSAGE_INTERACTION,
  };

  const gtmVideoMessageProperties: GTMVideoMessageProperties =
    mapToGtmVideoMessageProperties(videoMessageProperties);
  const gtmVideo: GTMVideoAttributes = mapToGTMVideoAttributes(video);

  if (action === GTMVideoMessageInteractionAction.SHARE) {
    pushToDataLayer({
      ...base,
      action: GTMVideoMessageInteractionAction.SHARE,
      share_option: shareOption, // Share only
      ...gtmVideo,
      ...gtmVideoMessageProperties,
      ...vehicleData,
    });
  } else {
    pushToDataLayer({
      ...base,
      action: action,
      ...gtmVideo,
      ...gtmVideoMessageProperties,
      ...vehicleData,
    });
  }
}
